import React from 'react';
import { Body, Box, Heading } from '@hover/blueprint';
import { ArrowButton } from '@hover/shared-components';
import { Link } from 'gatsby';

interface IStartTodayProps {
  heading: string;
  body: string;
  cta: {
    label: string;
    href: string | (() => void);
  };
}

const StartToday: React.FC<IStartTodayProps> = ({ heading, body, cta }) => (
  <Box
    p={10}
    maxW={{ base: 'calc(100% - 32px)', desktop: '6xl' }}
    w="100%"
    bgColor="primary.100"
    borderRadius={8}
    justifyContent="center"
    mb={{ base: 4, desktop: 16 }}
  >
    <Box
      maxW={{ base: '100%', desktop: '5xl' }}
      w="100%"
      justifyContent="space-between"
      alignItems="center"
      flexDirection={{ base: 'column', desktop: 'row' }}
    >
      <Box d="block">
        <Heading
          as="h2"
          color="primary.900"
          size={{ base: 500, desktop: 600 }}
          sx={{ mb: 2 }}
        >
          {heading}
        </Heading>
        <Body color="primary.900" maxW="2xl">
          <Box
            fontSize={{ base: 18, desktop: 24 }}
            lineHeight={{ base: 7, desktop: 9 }}
          >
            {body}
          </Box>
        </Body>
      </Box>
      {typeof cta.href === 'string' ? (
        <ArrowButton
          colorScheme="primary"
          variant="solid"
          to={cta.href}
          as={Link}
          w={{ base: '323px', tablet: 'auto' }}
          mt={{ base: 8, desktop: 0 }}
        >
          {cta.label}
        </ArrowButton>
      ) : (
        <ArrowButton
          colorScheme="primary"
          variant="solid"
          onClick={cta.href}
          w={{ base: '323px', tablet: 'auto' }}
          mt={{ base: 8, desktop: 0 }}
        >
          {cta.label}
        </ArrowButton>
      )}
    </Box>
  </Box>
);

export default StartToday;
